{
    "filter_button__text": "Filtern",
    "filter_search__aria_label": "In Liste suchen",
    "filter_modal__title": "Filter",
    "remove_all": "Alle entfernen",
    "quick_filters__customers_my_plus_customers": "🚀 Größtes Ausbaupotenzial",
    "quick_filters__customers_my_minus_customers": "⚠️ Stärkste Abwanderungen",
    "quick_filters__orders_my_open_orders": "Offene Aufträge",
    "quick_filters__orders_my_billed_orders": "Fakturierte Aufträge",
    "quick_filters__quotes_my_open_quotes": "Offene Angebote",
    "date_range_filter__newer_than": "ist in den letzten",
    "date_range_filter__older_than": "ist älter als",
    "date_range_filter__range_mode": "ist im Zeitraum",
    "date_range_filter__please_select": "Bitte auswählen",
    "date_range_filter__unit_label": "Einheit",
    "date_range_filter__unit_days": "Tage",
    "date_range_filter__unit_weeks": "Wochen",
    "date_range_filter__unit_months": "Monate",
    "price_range_filter__than": "Als",
    "price_range_filter__is": "ist",
    "price_range_filter__greater": "Größer",
    "price_range_filter__smaller": "Kleiner",
    "save_view": "Ansicht speichern",
    "save_view_dialog__title": "Ansicht speichern",
    "save_view_dialog__name_placeholder": "Namen eingeben",
    "save_view_dialog__visibility_label": "Wer soll die Ansicht sehen?",
    "save_view_dialog__visibility_only_me": "Nur ich",
    "save_view_dialog__visibility_team": "Alle in meinem Team",
    "save_view_dialog__clear_all": "Alle Löschen",
    "save_view_dialog__cancel": "Abbrechen",
    "save_view_dialog__save": "Ansicht speichern",
    "save_view_dialog__name_required": "Bitte gib dieser Ansicht einen Namen",
    "save_view_dialog__name_too_long": "Ansichtsname darf maximal 255 Zeichen lang sein",
    "saved_views__all_views": "Alle Ansichten",
    "saved_views__my_views": "Meine Ansichten",
    "saved_views__shared_views": "Geteilte Ansichten",
    "saved_views__edit": "Bearbeiten",
    "saved_views__delete": "Löschen",
    "saved_views__delete_confirmation_title": "Filteransicht löschen",
    "saved_views__delete_confirmation_description": "Bist du sicher, dass du diese Filteransicht löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "edit_view_dialog__title": "Ansicht bearbeiten",
    "edit_view_dialog__update": "Ansicht aktualisieren"
}
